import React from 'react';
import './styles.scss';
import GridPage from "../../grids/gridPage";

const MyReports = ({history}) => {

    const canEditByRow = (col, row) => {
        const arrayOfColNames = [
            "actualDepartureDate",
            "actualDeliveryDate",
            "awardAgent",
            "profitPooling",
            "deliveryCost",
            "costPrice",
            "discountForCustomer",
            "insuranceCost",
            "actualCostForAgent",
            "actualDeliveryCost",
            "actualWeight",
            "deliveryDate"
        ];

        const arrayOfStatuses = [
            'Completed',
            'InvoicePaid',
            'InvoiceIssued'
        ]

        return !(arrayOfColNames.includes(col.fieldName) && arrayOfStatuses.includes(row.statusCode));
    }

    return (
        <div>
            <GridPage
                history={history}
                gridName={'parcels'}
                label={'Мои отчеты'}
                canEditByRow={canEditByRow}
            />
        </div>
    );
};

export default MyReports;


// WEBPACK FOOTER //
// ./App/pages/reports/myReports.jsx